/*********************************************************
 *                  Admin users Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("DeviceCtrl", ["$scope", "Utils", "devices", "$uibModal", "DeviceService", "toastr", function ($scope, Utils, devices, $uibModal, DeviceService, toastr) {

		/************************************************************************************************************
             *  SETUP
             *************************************************************************************************************/

		$scope.data = {
			devices: devices.data
		};

		var deleteModal;


		/************************************************************************************************************
             *  $scope functions
             *************************************************************************************************************/
		/**
             * Ouvrir la modal de suppression d'un device.
             */
		$scope.openDeleteModal = function (device) {
			$scope.data.entityToDelete = device;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/************************************************************************************************************
             *  WEB SERVICE DELETE
             *************************************************************************************************************/
		$scope.deleteDevice = function (device) {
			DeviceService.deleteDeviceById(device.id)
				.then(() => {
					DeviceService.getAllDevicesByClient().then(function (data) {
						$scope.data.devices = data;
					});
					toastr.success("", "Appareil supprimé");
					deleteModal.close();
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Impossible de supprimer l'appareil"), "Problème lors de la suppression de l'appareil");
				});
		};

		$scope.setDeviceActiveStatus = function (device, status) {
			DeviceService.editDeviceActiveStatus(device.id, status).then((response) => {
				const data = response.data;
				toastr.success("", "L'appareil " + data.serviceNumber + " a été bien été mis à jour");
				DeviceService.getAllDevicesByClient().then(function (data) {
					$scope.data.devices = data;
				});
			}).catch((error) => {
				const data = error.data;
				let errorMessage = "Problème lors de la mise à jour de l'appareil. ";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};
	}]
	);